import { render, staticRenderFns } from "./lendManage.vue?vue&type=template&id=3bafd6be&scoped=true&"
import script from "./lendManage.vue?vue&type=script&lang=js&"
export * from "./lendManage.vue?vue&type=script&lang=js&"
import style0 from "./lendManage.vue?vue&type=style&index=0&id=3bafd6be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bafd6be",
  null
  
)

export default component.exports